import React, { useEffect, useState } from "react";
import EditGold from "./editProducts/editGoldProduct";
import EditDiamond from "./editProducts/edtDiamondProduct";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../constants/appConfig";
import {
  Box,
  Container,
  CircularProgress,
} from "@mui/material";

const Index = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const productId = searchParams.get("productId");
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);

  const getProduct = async () => {
    try {
      const API = API_URL + "/product/findById?productId=" + productId;
      const response = await fetch(API);
      const data = await response.json();
      setProduct(data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (productId) {
      getProduct();
    }
  }, []);

  return (
    <Box 
      sx={{ 
        width: '100%', 
        minHeight: '100vh',
        bgcolor: 'grey.50',
        pt: 2
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1600px',
          mx: 'auto',
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress size={60} />
          </Box>
        ) : (
          <Box sx={{ width: '100%' }}>
            {product.productGold === true ? (
              <EditGold fetchedProduct={product} />
            ) : product.productGold === false ? (
              <EditDiamond fetchedProduct={product} />
            ) : null}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Index;
